import type { ReactNode } from "react";

// Message keys: hero.pages.<key>.title / .body
export const HERO_PAGES = ["infra", "network", "apps", "web", "vpn", "backup", "domains", "email", "ssl", "kubernetes", "storage", "database", "protection", "maintenance"] as const;

/** A button under the hero text. */
export type HeroAction = { label: string; href: string };

/** One hero page: the headline (a word between stars gets the highlight block), an optional line under it and optional art. */
export type HeroPage = { title: string; body?: string; art?: ReactNode };

/** The page after `current`, wrapping to the first. */
export function nextHeroPage(current: number, count: number): number {
  return (current + 1) % count;
}
